export default __webpack_public_path__ + "static/media/endCallNew.5e08990a.svg";